import AscModal from "../AscModal/AscModal";
import { AdminSuccessIcon, CloseIcon } from "../AscIcons";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import classNames from "classnames";
import styles from "./AscModalConfirmation.module.scss";

export interface AscModalConfirmationProps {
  className?: string;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  header: string;
  title: string;
}

function AscModalConfirmation({
  className,
  visible,
  setVisible,
  header,
  title,
}: AscModalConfirmationProps) {
  function closeModal() {
    setVisible(false);
  }

  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.modalClassName}
      withBackground={false}
    >
      <div
        className={classNames(styles.ground, className)}
        data-testid="asc-modal-confirmation"
      >
        <CloseIcon
          className={styles.closeIcon}
          onClick={closeModal}
          data-testid={"test-close-icon"}
        />
        <AdminSuccessIcon className={styles.successIcon} />
        <AscHeading level={6} className={styles.header}>
          {header}
        </AscHeading>
        <span className={styles.title}>{title}</span>
      </div>
    </AscModal>
  );
}

export default AscModalConfirmation;
